function createButtonStyles({
  activeBackgroundColor,
  defaultBackgroundColor,
  defaultBorderColor,
  defaultColor,
  disabledBackgroundColor,
  disabledBorderColor,
  disabledColor,
  disabledFocusBoxShadow,
  focusBoxShadow,
  hoverBackgroundColor
}) {
  return {
    backgroundColor: defaultBackgroundColor,
    borderColor: defaultBorderColor,
    color: defaultColor,
    "&:hover": {
      backgroundColor: hoverBackgroundColor,
      color: defaultColor
    },
    "&:focus": {
      boxShadow: focusBoxShadow
    },
    "&:active": {
      backgroundColor: activeBackgroundColor,
      boxShadow: "none",
      color: defaultColor
    },
    "&:disabled, &[aria-disabled=true]": {
      backgroundColor: disabledBackgroundColor,
      borderColor: disabledBorderColor,
      color: disabledColor,
      pointerEvents: "none",
      "&:active": {
        backgroundColor: disabledBackgroundColor || defaultBackgroundColor || "transparent",
        boxShadow: disabledFocusBoxShadow || focusBoxShadow,
        color: disabledColor || defaultColor || "inherit"
      },
      "&:focus": {
        boxShadow: disabledFocusBoxShadow
      }
    }
  };
}
export {
  createButtonStyles
};
